module.exports = __webpack_public_path__ + "img/Logo_BM_pion_400.577013fe.png";